import React from "react";
import PageTemplate from "../../../templates/page-template";

export default function BecomeABuddyPage() {
	return (
		<PageTemplate header="Become A Buddy"/>
	);
}
